import { FC, useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Col, Tooltip, Image } from "antd";
import { Button } from "../../../../../ui-components/Button";
import { Modal } from "../../../../../ui-components/Modal";
import { Paragraph } from "../../../../../ui-components/Typography";
import { sendToYumana, setInitialYumanaState } from "../../../store";
import { useAppDispatch, useAppSelector } from "../../../../../utils/hooks";
import { State } from "../../../../../utils/store";
import {
  errorNotification,
  successNotification,
} from "../../../../../ui-components/Notification";
import yumanaIcon from "../../../../../assets/icons/Yumana.png";
import { ActionButton } from "../../../../../share/company/components/ui-share";

interface YumanaButtonProps {
  companyUUID: string;
  clientUUID: string;
  campaignUUID: string;
}

export const YumanaButton: FC<YumanaButtonProps> = ({ companyUUID, clientUUID, campaignUUID }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const { success, message, loading } = useAppSelector(
    (state: State) => state.goldenBasket.sendToYumana
  );

  useEffect(() => {
    if (success === true && loading === false) {
      successNotification("The company has been sent to your Yumana platform");
      handleModalClose();
      dispatch(setInitialYumanaState());
    } else if (success === false) {
      errorNotification(message);
    }
  }, [dispatch, success, message, loading]);

  // Reset state when component unmounts or modal is closed
  useEffect(() => {
    return () => {
      dispatch(setInitialYumanaState());
    };
  }, [dispatch]);

  const handleModalClose = () => {
    setModalVisible(false);
    dispatch(setInitialYumanaState());
  };

  const handleYumanaShare = () => {
    dispatch(sendToYumana({ companyUUID, clientUUID, campaignUUID }));
  };

  return (
    <Col className="gutter-row">
      <Tooltip placement="top" title="Send company back to Yumana">
        <ActionButton onClick={() => setModalVisible(true)}>
          <StyledImage src={yumanaIcon} alt="Yumana" preview={false} />
        </ActionButton>
      </Tooltip>

      <Modal
        title="Send to Yumana"
        visible={modalVisible}
        onCancel={handleModalClose}
        handleSubmit={handleYumanaShare}
        footer={[
          <Button key="cancel" onClick={handleModalClose}>
            Cancel
          </Button>,
          <Button
            key="send"
            onClick={handleYumanaShare}
            loading={loading}
            disabled={loading}
          >
            {loading ? "Sending" : "Send"}
          </Button>,
        ]}
      >
        <ModalContent>
          <Paragraph>Click send to add this Company to your Yumana platform</Paragraph>
        </ModalContent>
      </Modal>
    </Col>
  );
};

const StyledImage = styled(Image)`
  width: var(--gb-header-icon-size);
  height: var(--gb-header-icon-size);
`;

const ModalContent = styled.div`
  padding: 1rem 0;
`; 